import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DOCUMENT, DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';
import { MapService} from '../../services/mapservice';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.scss'],
})
export class GoogleMapComponent implements OnInit {
  regionCode!: string;
  searchedPlaces: string[] = [];
  isLocRequired: boolean = false;
  // storedAddresses: string[] = [];
  storedAddresses: any;
  searchedAutoPlaces: any[] = [];
  @Input() isAddressRequired: any;
  @Input() isSearchNotRequired: any;
  @Input() isPopupShow!: Subject<any>;
  @Input() searchLocation: any;
  @Output() searchLocationEvent: EventEmitter<any> = new EventEmitter();
  @Output() serviceTypeDetailsEvent = new EventEmitter();

// searchlocation:any;
  locationInfo: any = localStorage.getItem('locationInfo');
  userListSubmit: any = localStorage.getItem('userListSubmit');
  userInfo: any = localStorage.getItem('loginUserInfoDetails');
  private map!: google.maps.Map;
  private markers: google.maps.Marker[] = [];
  infoWindows: google.maps.InfoWindow[] = [];
  infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow()
  // searchLocation: string;

  constructor(private datePipe: DatePipe,    @Inject(DOCUMENT) private document,
  private elementRef: ElementRef,private http:HttpClient, private mapService: MapService,private agentscriptservice: AgentscriptService_updated) {
    // this.storedAddresses = this.getStoredAddresses();

  }

  // ngAfterViewInit() {
  //   // this.mapElement = document.getElementById('map'+this.count) as HTMLElement;
  //   this.mapElement = document.getElementById('map') as HTMLElement;

  //   if (!this.mapElement) {
  //     console.error('Map element with ID "map" not found in the DOM.');
  //   }
  // }


    // "x": longitude: -85.13718032318815
    // "y": latitude: 41.079180963233135


  mapElement!: HTMLElement;
  count:any;
  ngOnChanges()
  {
    this.agentscriptservice.locationcoordinates='';
    console.log(this.agentscriptservice.locationcoordinates)
  }
  showStreetView() {
    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    var locationcoordinates=this.agentscriptservice.fetchData(this.tab_title,'mapdata')
    const location = { lat: 28.5355, lng: 77.391 };

    // Initialize center coordinates variable
    let centerLatLng: google.maps.LatLngLiteral;
    console.log(locationcoordinates)
console.log(this.agentscriptservice.locationcoordinates)
    // Check if the center coordinates are available in agentscriptservice
    if (locationcoordinates && locationcoordinates.lng && locationcoordinates.lat) {
        centerLatLng = { lng: +locationcoordinates.lng, lat: +locationcoordinates.lat };
    } else {
        // Use Fort Wayne's coordinates as default if center coordinates are not available
        centerLatLng = { lng: -85.1205, lat: 41.1373 };
    }

    // Define map options with the center coordinates
    const mapOptions: google.maps.MapOptions = {
      center: centerLatLng,
      zoom: 15,
      tilt: 45, // Adjust the tilt angle here (0 for straight down, 45 for 45 degrees tilt, etc.)
      disableDefaultUI: true, // Disable all default UI controls
      zoomControl: true, // Enable zoom control
      streetViewControl: false, // Disable street view control
      mapTypeControl: false, // Disable map type control
      fullscreenControl: false // Disable fullscreen control
  };

    // Check if the map reference is available
    if (!this.mapRef || !this.mapRef.nativeElement) {
        console.error('Map reference not found.');
        return;
    }

    const mapElement = this.mapRef.nativeElement;

    // Create a new map instance with the specified options
    const map = new google.maps.Map(mapElement, mapOptions);

    // Create a StreetViewService instance
    const streetViewService = new google.maps.StreetViewService();

    // Check if the center location is available
    if (mapOptions.center) {
        // Request panorama data for the center location
        streetViewService.getPanorama(
            {
                location: mapOptions.center,
                radius: 50
            },
            (data, status) => {
                if (status === 'OK') {
                    if (data && data.location) {
                        // Create a Street View panorama
                        const panorama = new google.maps.StreetViewPanorama(
                            mapElement,
                            {
                              position: data.location.latLng,
                              pov: { heading: 165, pitch: 0 },
                              zoom: 1,
                              // linksControl: false, // Disable Street View links
                              panControl: true, // Disable pan control
                              addressControl: false, // Disable address control
                              enableCloseButton: false // Disable close button
                          }
                        );
                        // Set Street View panorama on the map
                        map.setStreetView(panorama);
                    } else {
                        console.error('Street View data not found for this location');
                    }
                } else {
                    console.error('Street View data request failed with status:', status);
                }
            }
        );
    } else {
        console.error('Map center is not defined.');
    }
}



  @ViewChild('mapRef') mapRef: ElementRef;


  // ngAfterViewInit() {
  //   var s = this.document.createElement('script');
  //   s.type = 'text/javascript';
  //   s.src =
  //     'https://maps.googleapis.com/maps/api/js?key=AIzaSyCcZBjQq8GUmtPJIhlKy1V94jhu4q16lS8&libraries=geometry';
  //   this.elementRef.nativeElement.appendChild(s);
  // }
  tab_title: any;
  ngOnInit() {
    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    this.showStreetView()
    var self = this;
    setTimeout(function () {
      self.showMap();
    }, 2000);
  }

  showMap() {
    console.log(this.mapRef.nativeElement);
    const location = { lng: -85.1205, lat: 41.1373 };
    var options = {
      center: location,
      zoom: 8,
    };

    const map = new google.maps.Map(this.mapRef.nativeElement, options);
    // this.addMarket(map, location);
    console.log('maps', google.maps);
  }
  addMarket(pos, map) {
    return new google.maps.Marker({
      position: pos,
      map: map,
    });
  }
}
function p(p: any, arg1: (any: any) => any) {
  throw new Error('Function not implemented.');
}
